import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router';

export const useAppNavigate = useNavigate;
export const useAppLocation = useLocation;
export const useAppParams = useParams;
export const useAppSearchParams = useSearchParams;

export const useAppBack = (): (() => void) => {
  const navigate = useNavigate();
  return () => {
    navigate(-1);
  };
};
